"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const totangoTheme_1 = require("../../theme/totangoTheme");
const typography_1 = __importDefault(require("../typography/typography"));
const variantBySize = {
    large: 'subtitle1',
    medium: 'body2',
    small: 'overline',
};
const Button = ({ className, children, disabled, isLoading, size, textVariant, ...restProps }) => (react_1.default.createElement(core_1.MuiThemeProvider, { theme: totangoTheme_1.totangoTheme },
    react_1.default.createElement(Button_1.default, { classes: { root: (0, classnames_1.default)(className, { loading: isLoading }) }, className: (0, classnames_1.default)(className, { loading: isLoading }), disabled: disabled || isLoading, ...restProps },
        react_1.default.createElement(typography_1.default, { component: "span", variant: textVariant || variantBySize[size], classes: { root: 'button-typography' } },
            isLoading && react_1.default.createElement("i", { className: "fa fa-spin fa-spinner", style: { marginRight: '7px' } }),
            children))));
Button.defaultProps = {
    className: '',
    color: 'default',
    disableElevation: false,
    disableFocusRipple: false,
    endIcon: undefined,
    fullWidth: false,
    isLoading: false,
    href: undefined,
    size: 'medium',
    startIcon: undefined,
    variant: 'text',
    textVariant: undefined,
    onClick: noop_1.default,
};
Button.propTypes = {
    onClick: prop_types_1.default.func,
    className: prop_types_1.default.string,
    color: prop_types_1.default.oneOf(['default', 'secondary', 'primary', 'inherit']),
    disableElevation: prop_types_1.default.bool,
    disableFocusRipple: prop_types_1.default.bool,
    endIcon: prop_types_1.default.element,
    isLoading: prop_types_1.default.bool,
    fullWidth: prop_types_1.default.bool,
    href: prop_types_1.default.string,
    size: prop_types_1.default.oneOf(['small', 'medium', 'large']),
    startIcon: prop_types_1.default.element,
    variant: prop_types_1.default.oneOf(['text', 'outlined', 'contained']),
    textVariant: prop_types_1.default.oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'overline',
        'inherit',
    ]),
};
exports.default = Button;
//# sourceMappingURL=button.js.map